import AllRouter from "./component/AllRouter";


function App() {
  return (
    <>
      <AllRouter/>
    </>
  );
}

export default App;
